module.exports = __webpack_public_path__ + "static/media/iphone XR.a68b88ef.jpg";